import { Component, Input, AfterViewInit, OnInit } from '@angular/core';
import { ArgyleIncomeStream } from 'src/app/models/Argyle';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { ApplicantDataService } from 'src/app/services/applicant-data.service';
import { GroupApplicantsService } from 'src/app/services/group-applicants.service';
import { FileDownloadService } from 'src/app/services/file-download.service';
import { resourceLimits } from 'worker_threads';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-w2-upload',
  templateUrl: './w2-upload.component.html',
  styleUrls: ['./w2-upload.component.less']
})
export class W2UploadComponent {
  @Input() stream :ArgyleIncomeStream;
  overlays : any[];
  urlToUse : SafeUrl; 
  loading: boolean = false;
  constructor(public modalService: NgbModal,public fileDownload: FileDownloadService, private toast: ToastrService, private auth: AuthService, public appData: ApplicantDataService,private sanitizer : DomSanitizer,private http: HttpClient,public groups: GroupApplicantsService) { }
  ngOnInit(): void {
    console.log('STREAM',this.stream);
  }
  ngAfterViewInit(): void {
    

    // this.activeId = this.stream.historicalData[0].reportId;
    // if(this.stream.historicalData[0].metadata.ocr_authenticity.doc_analysis[0].form_analysis[0].visualizations[0].page_visualizations &&
    //   this.stream.historicalData[0].metadata.ocr_authenticity.doc_analysis[0].form_analysis[0].visualizations[0].page_visualizations.length > 0)
    //   {
    //     this.appData.GetOverlayList(this.stream.recordId).subscribe((res : any[])=>{
    //       this.overlays = res;
    //       console.log(this.overlays);
    //     })
    //   }
  }

  clearReport()
  {
    this.urlToUse = null;
  }

  setOverlay(recordId : number, index: number)
  {
    this.loading = true;
    this.urlToUse = null;
    this.http.get(`${environment.baseURl}/api/incomever/overlay/${recordId}/${index}`, { responseType: 'blob' })
    .subscribe(blob => {
      const url = URL.createObjectURL(blob);
      this.urlToUse = this.sanitizer.bypassSecurityTrustUrl(url);
      this.loading = false;
    });
  }

  download(i : any, doctype: number)
  {
    this.appData.DownloadArgyleDoc(i.id,i.file_name, this.stream.inviteId, doctype).subscribe(res=>{
      this.fileDownload.HandleFileDownload(res, 'pdf', i.file_name);
    })
  }
}
